<div class="customize-codification-values__container-edition-encoding">
  <div class="customize-codification-values__container-color-text">
    <div>
      <div class="common-dropdown-list__button-colors"
        (click)="toggleFilter($event, selectorColorsEncoding)">
        <i [class]="'lf-icon-step-final common-icon__md-code-color-' + (customizeCodificationValues.editingEncodingItem.color | colors:'highlightListColors')"></i>
        <button class="common-button__icon-sm-noborder">
          <i class="common-icon__md"
            [ngClass]="selectorColorsEncoding?.visible?'lf-icon-angle-up':'lf-icon-angle-down'"></i>
        </button>
      </div>
      <p-menu #selectorColorsEncoding
        styleClass="common-dropdown-list__container-colors"
        appendTo="body"
        [model]="customizeCodificationValues.listColors"
        [popup]="true">
        <ng-template pTemplate="action"
          let-color>
          <button class="common-dropdown-list__si-button"
            (click)="customizeCodificationValues.editingEncodingItem.color = color.color">
            <i [class]="'lf-icon-step-final common-icon__md-code-color-' + (color.listValueColorId | colors:'highlightListColors')"></i>
          </button>
        </ng-template>
      </p-menu>
    </div>
    <div class="common-text-input__field-container">
      <label class="common-text-input__block-field-input"
        [ngClass]="{'common-text-input__block-field-input--with-value': customizeCodificationValues.editingEncodingItem.text,
            'common-text-input__block-field-input--error': customizeCodificationValues.editingEncodingItem.textError }"
        [for]="'new-value-customize-field-encoding-formu'">
        <input class="common-text-input__input"
          type="text"
          autocomplete="off"
          [id]="'new-value-customize-field-encoding-formu'"
          [name]="'new-value-customize-field-encoding-formu'"
          [placeholder]="'customize-field-formula.placeholder-add-encoding-value' | afTranslate"
          [(ngModel)]="customizeCodificationValues.editingEncodingItem.text"
          (blur)="checkErrorValue('text', customizeCodificationValues.editingEncodingItem)"/>
        @if(customizeCodificationValues.editingEncodingItem.text){
          <button class="common-text-input__icon-clean-input"
            tabindex="-1"
            (click)="customizeCodificationValues.editingEncodingItem.text = ''">
            <i class="lf-icon-close-thick common-icon__sm"></i>
          </button>
        }
      </label>
      @if(customizeCodificationValues.editingEncodingItem.textError){
        <div class="common-text-input__mandatory-tag"
          [afTranslate]="'customize-field-list.error-empty-value'">
        </div>
      }
    </div>
  </div>
  <div class="customize-codification-values__container-operation">
    <div class="picker-visibility__operators-container">
      <div class="common-text-input__field-container-different-values">
        <div class="common-customize-values__block"
          [ngClass]="{'common-customize-values__block--error': customizeCodificationValues.editingEncodingItem?.operator1Error}">
          @for (operator of customizeCodificationValues.firstOperator; track $index) {
            <button class="common-button__value-formu"
              [ngClass]="{'common-button__value-formu--selected': operator.listValueId === customizeCodificationValues.editingEncodingItem?.operator1}"
              (click)="operatorSelected(operator, 'operator1', customizeCodificationValues.editingEncodingItem)">{{operator.text}}</button>
            @if(!$last){
              <div class="common-divider__vertical-grey-400 h-[14px]"></div>
            }
          }
        </div>
        @if(customizeCodificationValues.editingEncodingItem?.operator1Error){
          <div class="common-text-input__mandatory-tag"
            [afTranslate]="'customize-field.error-configuration'">
          </div>
        }
      </div>
      <div class="common-text-input__block-number">
        <div class="common-text-input__block-number">
          <label class="common-text-input__block-field-input"
            for="customize-formula-input-value1"
            [ngClass]="{'common-text-input__block-field-input--with-value': customizeCodificationValues.editingEncodingItem?.value1,
              'common-text-input__block-field-input--error': customizeCodificationValues.editingEncodingItem?.value1Error }"
            [attr.disabled]="field.noEditable || !customizeCodificationValues.editingEncodingItem?.operator1?true:null">
            <p-inputNumber class="common-text-input__container-input"
              styleClass="common-text-input__input-number"
              [inputId]="'customize-formula-input-value1'"
              mode="decimal"
              [placeholder]="'common.value' | afTranslate"
              [useGrouping]="false"
              [maxFractionDigits]="2"
              [min]="0"
              [disabled]="field.noEditable || !customizeCodificationValues.editingEncodingItem?.operator1"
              [(ngModel)]="customizeCodificationValues.editingEncodingItem.value1"
              (onBlur)="checkErrorValue('value1', customizeCodificationValues.editingEncodingItem)"></p-inputNumber>
          </label>
        </div>
        @if(customizeCodificationValues.editingEncodingItem?.value1Error){
          <div class="common-text-input__mandatory-tag"
            [afTranslate]="'common.error'">
          </div>
        }
      </div>
      <div class="common-text-input__field-container-different-values">
        <div class="common-customize-values__block"
          [attr.disabled]="field.noEditable || !isNumber(customizeCodificationValues.editingEncodingItem?.value1) || customizeCodificationValues.editingEncodingItem.operator1 === '=' || customizeCodificationValues.editingEncodingItem.operator1 === '<>'?true:null">
          @for (operator of customizeCodificationValues.secondOperator; track $index) {
            <button class="common-button__value-formu"
              [ngClass]="{'common-button__value-formu--selected': operator.listValueId === customizeCodificationValues.editingEncodingItem?.operator2}"
              [disabled]="field.noEditable || !isNumber(customizeCodificationValues.editingEncodingItem?.value1) || customizeCodificationValues.editingEncodingItem.operator1 === '=' || customizeCodificationValues.editingEncodingItem.operator1 === '<>'"
              (click)="operatorSelected(operator, 'operator2', customizeCodificationValues.editingEncodingItem)">{{operator.text}}</button>
            @if(!$last){
              <div class="common-divider__vertical-grey-400 h-[14px]"></div>
            }
          }
        </div>
      </div>
      <div class="common-text-input__block-number">
        <div class="common-text-input__block-number">
          <label class="common-text-input__block-field-input"
            for="customize-formula-input-value2"
            [ngClass]="{'common-text-input__block-field-input--with-value': customizeCodificationValues.editingEncodingItem?.value2,
              'common-text-input__block-field-input--error': customizeCodificationValues.editingEncodingItem?.value2Error }"
            [attr.disabled]="field.noEditable || !customizeCodificationValues.editingEncodingItem?.operator2?true:null">
            <p-inputNumber class="common-text-input__container-input"
              styleClass="common-text-input__input-number"
              [inputId]="'customize-formula-input-value2'"
              mode="decimal"
              [placeholder]="'common.value' | afTranslate"
              [useGrouping]="false"
              [maxFractionDigits]="2"
              [min]="0"
              [disabled]="field.noEditable || !customizeCodificationValues.editingEncodingItem?.operator2"
              [(ngModel)]="customizeCodificationValues.editingEncodingItem.value2"
              (onBlur)="checkErrorValue('value2', customizeCodificationValues.editingEncodingItem)"></p-inputNumber>
          </label>
        </div>
        @if(customizeCodificationValues.editingEncodingItem?.value2Error){
          <div class="common-text-input__mandatory-tag"
            [afTranslate]="'common.error'">
          </div>
        }
      </div>
    </div>
    <div class="picker-visibility__operators-buttons-container">
      <button class="common-button__icon-md-noborder"
        (click)="addEncodingValue()">
        <i class="lf-icon-check common-icon__md"></i>
      </button>
      @if(field.fieldEncodings?.length){
        <button class="common-button__icon-md-noborder"
          (click)="closeEncodingValue()">
          <i class="lf-icon-close common-icon__md"></i>
        </button>
      }
    </div>
  </div>
</div>

